module.exports = __webpack_public_path__ + "static/media/09_digginglight.7efface9.jpg";